const state = () => ({
  schemeCreationNotifications: {
    seenNotifications: [],
    unseenNotifications: []
  },
  euCallNotifications: {
    seenNotifications: [],
    unseenNotifications: []
  },
  hasModalError: false,
  modalErrorMessage: ""
});

const getters = {};

const actions = {};

const mutations = {
  updateSchemeCreationNotifications(state, val) {
    state.schemeCreationNotifications.seenNotifications = val.seenNotifications;
    state.schemeCreationNotifications.unseenNotifications =
      val.unseenNotifications;
  },

  updateEuCallNotifications(state, val) {
    state.euCallNotifications.seenNotifications = val.seenNotifications;
    state.euCallNotifications.unseenNotifications = val.unseenNotifications;
  },

  enableModalError(state) {
    state.hasModalError = true;
  },

  disableModalError(state) {
    state.hasModalError = false;
  },

  updateModalError(state, message) {
    state.modalErrorMessage = message;
  }
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
